import { configStore, contractsStore, loginStore } from "../state/CommonState"
import { useSnapshot } from "valtio"
import HomeScreenLCLv3 from "./home-screen-lcl-v3"

export default function HomeScreenv3(props) {
    useSnapshot(contractsStore)
    const rec = contractsStore.current
    //if (!rec || !rec.shipmentType) return <></>
    const stype = configStore.homescreenCurrentShipmentType
    console.log(props,"****",stype);
    switch(stype) {
        case 'LCL': return <HomeScreenLCLv3 shipmentType={stype} {...props}/>
        case 'FCL': return <HomeScreenLCLv3 shipmentType={stype} {...props}/>
        case 'Air': return <HomeScreenLCLv3 shipmentType={stype} {...props}/>
    }
}